import React from 'react';
import { Info } from 'lucide-react';

const RecurringFields = ({ editedFields, setEditedFields }) => {
    // Get explanation text for recurring type
    const getTypeExplanation = () => {
        return "Choose specific days for the task to repeat. Select all days for daily tasks, or specific days for custom schedules.";
    };

    const toggleAllDays = () => {
        const allDays = [0, 1, 2, 3, 4, 5, 6];
        // If all days are currently selected, clear the selection
        // Otherwise, select all days
        const newAssignedDays = editedFields.assignedDays.length === 7 ? [] : allDays;
        setEditedFields(prev => ({ ...prev, assignedDays: newAssignedDays }));
    };

    return (
        <div className="space-y-4">
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Recurring Days
                </label>
                <div className="relative">
                    <div className="group relative mt-1">
                        <div className="flex items-center text-gray-500 text-sm">
                            <Info size={16} className="mr-1" />
                            <span className="text-xs">What's this?</span>
                        </div>
                        <div className="invisible group-hover:visible absolute left-0 top-full mt-1 p-2 bg-white border rounded shadow-lg text-sm text-gray-600 z-10 w-100">
                            {getTypeExplanation()}
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <div className="flex flex-wrap gap-2">
                    <button
                        className={`px-3 py-2 rounded-full transition-colors duration-200 ${editedFields.assignedDays.length === 7
                                ? 'bg-purple-500 text-white'
                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                            }`}
                        onClick={toggleAllDays}
                    >
                        All Days
                    </button>
                    {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day, index) => (
                        <button
                            key={day}
                            className={`px-3 py-2 rounded-full transition-colors duration-200 ${editedFields.assignedDays.includes(index)
                                    ? 'bg-purple-500 text-white'
                                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                }`}
                            onClick={() => {
                                const newAssignedDays = editedFields.assignedDays.includes(index)
                                    ? editedFields.assignedDays.filter(d => d !== index)
                                    : [...editedFields.assignedDays, index].sort((a, b) => a - b);
                                setEditedFields(prev => ({ ...prev, assignedDays: newAssignedDays }));
                            }}
                        >
                            {day}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default RecurringFields;